export const APP_CONFIG = {
  name: 'BlastTime',
  description: 'Advertise to 50,000+ active BlastTime users'
}

export const SUBSCRIPTION_PLANS = [
  {
    id: 'basic',
    name: 'Basic',
    price: 99,
    features: ['Up to 5 active ads', '10K monthly impressions', 'Basic analytics', 'Email support'],
    stripeProductId: 'prod_SZqu09teQtBPlW',
    stripePriceId: 'price_1RehCFDTZBXX4XtFw5cQnRH5'
  },
  {
    id: 'professional',
    name: 'Professional',
    price: 299,
    features: ['Up to 20 active ads', '50K monthly impressions', 'Advanced analytics', 'Priority support'],
    stripeProductId: 'prod_SZqu6rEP3WOnG9',
    stripePriceId: 'price_1RehD1DTZBXX4XtF34Kog3ah'
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: 599,
    features: ['Unlimited ads', '200K monthly impressions', 'Premium analytics', '24/7 support'],
    stripeProductId: 'prod_SZqvyC7nbAoAnI',
    stripePriceId: 'price_1RehDaDTZBXX4XtF0xaKSMtS'
  }
]

export const OPTIONS = {
  businessTypes: [
    'Restaurant', 'Retail', 'Technology', 'Healthcare', 'Education',
    'Entertainment', 'Real Estate', 'Financial Services', 'Automotive',
    'Beauty & Wellness', 'Travel & Tourism', 'Professional Services', 'Other'
  ],
  interests: [
    'Food & Dining', 'Entertainment', 'Sports & Fitness', 'Technology',
    'Fashion', 'Travel', 'Music', 'Art & Culture', 'Education',
    'Health & Wellness', 'Business', 'Gaming', 'Photography', 'Shopping'
  ]
}

export const LIMITS = {
  fileSize: 10 * 1024 * 1024,
  allowedImageTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  allowedVideoTypes: ['video/mp4', 'video/webm', 'video/ogg'],
  maxPhotos: 5,
  maxVideos: 1,
  maxVideoDuration: 10
}

export const RADIUS_OPTIONS = [1, 5, 10, 25, 50, 100]

export const CREDIT_RATES = {
  costPerImpressionPerDay: 0.01,
  minCredits: 10,
  maxCredits: 10000
}

export const OTP_CONFIG = {
  length: 6,
  expiryMinutes: 10,
  resendDelaySeconds: 60
}

export const MAP_CONFIG = {
  defaultCenter: { lat: 18.5204, lng: 73.8567 },
  defaultZoom: 12,
  maxZoom: 18,
  minZoom: 8
}